var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "report-section free-exploration" }, [
    _c("h1", [_vm._v("Shape Drawing(Clockwise)")]),
    _c("div", { staticClass: "report-contents" }, [
      _vm.left && _vm.right
        ? _c("div", { staticClass: "table" }, [
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { width: "127" } }),
                  _c("th", { attrs: { width: "40" } }),
                  _c("th", { attrs: { width: "55" } }, [
                    _vm._v("[" + _vm._s(_vm.leftId) + "]")
                  ]),
                  _c("th", { attrs: { width: "55" } }, [
                    _vm._v("[" + _vm._s(_vm.rightId) + "]")
                  ]),
                  _c("th", { attrs: { width: "45" } })
                ])
              ]),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v("Shape Similarity")]),
                  _c("th", [_vm._v("Inner")]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.leftData.innerDataCW
                            ? _vm.leftData.innerDataCW.pathFollowIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rightData.innerDataCW
                            ? _vm.rightData.innerDataCW.pathFollowIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.diffLeftRight(
                            _vm.leftData.innerDataCW
                              ? _vm.leftData.innerDataCW.pathFollowIndex
                              : 0,
                            _vm.rightData.innerDataCW
                              ? _vm.rightData.innerDataCW.pathFollowIndex
                              : 0
                          )
                        ) +
                        " "
                    ),
                    _c("img", {
                      attrs: {
                        src:
                          "/img/icons/" +
                          _vm.upDownIcon(
                            _vm.leftData.innerDataCW
                              ? _vm.leftData.innerDataCW.pathFollowIndex
                              : 0,
                            _vm.rightData.innerDataCW
                              ? _vm.rightData.innerDataCW.pathFollowIndex
                              : 0
                          ),
                        width: "10",
                        height: "10"
                      }
                    })
                  ])
                ]),
                _c("tr", [
                  _c("th"),
                  _c("th", [_vm._v("Outer")]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.leftData.outerDataCW
                            ? _vm.leftData.outerDataCW.pathFollowIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rightData.outerDataCW
                            ? _vm.rightData.outerDataCW.pathFollowIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.diffLeftRight(
                            _vm.leftData.outerDataCW
                              ? _vm.leftData.outerDataCW.pathFollowIndex
                              : 0,
                            _vm.rightData.outerDataCW
                              ? _vm.rightData.outerDataCW.pathFollowIndex
                              : 0
                          )
                        ) +
                        " "
                    ),
                    _c("img", {
                      attrs: {
                        src:
                          "/img/icons/" +
                          _vm.upDownIcon(
                            _vm.leftData.outerDataCW
                              ? _vm.leftData.outerDataCW.pathFollowIndex
                              : 0,
                            _vm.rightData.outerDataCW
                              ? _vm.rightData.outerDataCW.pathFollowIndex
                              : 0
                          ),
                        width: "10",
                        height: "10"
                      }
                    })
                  ])
                ]),
                _c("tr", [
                  _c("th", [_vm._v("Circular Symmetry")]),
                  _c("th", [_vm._v("Inner")]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.leftData.innerDataCW
                            ? _vm.leftData.innerDataCW.circleIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rightData.innerDataCW
                            ? _vm.rightData.innerDataCW.circleIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.diffLeftRight(
                            _vm.leftData.innerDataCW
                              ? _vm.leftData.innerDataCW.circleIndex
                              : 0,
                            _vm.rightData.innerDataCW
                              ? _vm.rightData.innerDataCW.circleIndex
                              : 0
                          )
                        ) +
                        " "
                    ),
                    _c("img", {
                      attrs: {
                        src:
                          "/img/icons/" +
                          _vm.upDownIcon(
                            _vm.leftData.innerDataCW
                              ? _vm.leftData.innerDataCW.circleIndex
                              : 0,
                            _vm.rightData.innerDataCW
                              ? _vm.rightData.innerDataCW.circleIndex
                              : 0
                          ),
                        width: "10",
                        height: "10"
                      }
                    })
                  ])
                ]),
                _c("tr", [
                  _c("th"),
                  _c("th", [_vm._v("Outer")]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.leftData.outerDataCW
                            ? _vm.leftData.outerDataCW.circleIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rightData.outerDataCW
                            ? _vm.rightData.outerDataCW.circleIndex
                            : 0
                        ) +
                        " % "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.diffLeftRight(
                            _vm.leftData.outerDataCW
                              ? _vm.leftData.outerDataCW.circleIndex
                              : 0,
                            _vm.rightData.outerDataCW
                              ? _vm.rightData.outerDataCW.circleIndex
                              : 0
                          )
                        ) +
                        " "
                    ),
                    _c("img", {
                      attrs: {
                        src:
                          "/img/icons/" +
                          _vm.upDownIcon(
                            _vm.leftData.outerDataCW
                              ? _vm.leftData.outerDataCW.circleIndex
                              : 0,
                            _vm.rightData.outerDataCW
                              ? _vm.rightData.outerDataCW.circleIndex
                              : 0
                          ),
                        width: "10",
                        height: "10"
                      }
                    })
                  ])
                ]),
                _c("tr", [
                  _c("th", [_vm._v("Duration")]),
                  _c("th", [_vm._v("Inner")]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.leftData.innerDataCW
                            ? _vm.leftData.innerDataCW.time
                            : 0
                        ) +
                        " secs "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rightData.innerDataCW
                            ? _vm.rightData.innerDataCW.time
                            : 0
                        ) +
                        " secs "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.diffLeftRight(
                            _vm.leftData.innerDataCW
                              ? _vm.leftData.innerDataCW.time
                              : 0,
                            _vm.rightData.innerDataCW
                              ? _vm.rightData.innerDataCW.time
                              : 0
                          )
                        ) +
                        " "
                    ),
                    _c("img", {
                      attrs: {
                        src:
                          "/img/icons/" +
                          _vm.upDownIcon(
                            _vm.leftData.innerDataCW
                              ? _vm.leftData.innerDataCW.time
                              : 0,
                            _vm.rightData.innerDataCW
                              ? _vm.rightData.innerDataCW.time
                              : 0
                          ),
                        width: "10",
                        height: "10"
                      }
                    })
                  ])
                ]),
                _c("tr", [
                  _c("th"),
                  _c("th", [_vm._v("Outer")]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.leftData.outerDataCW
                            ? _vm.leftData.outerDataCW.time
                            : 0
                        ) +
                        " secs "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.rightData.outerDataCW
                            ? _vm.rightData.outerDataCW.time
                            : 0
                        ) +
                        " secs "
                    )
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.diffLeftRight(
                            _vm.leftData.outerDataCW
                              ? _vm.leftData.outerDataCW.time
                              : 0,
                            _vm.rightData.outerDataCW
                              ? _vm.rightData.outerDataCW.time
                              : 0
                          )
                        ) +
                        " "
                    ),
                    _c("img", {
                      attrs: {
                        src:
                          "/img/icons/" +
                          _vm.upDownIcon(
                            _vm.leftData.outerDataCW
                              ? _vm.leftData.outerDataCW.time
                              : 0,
                            _vm.rightData.outerDataCW
                              ? _vm.rightData.outerDataCW.time
                              : 0
                          ),
                        width: "10",
                        height: "10"
                      }
                    })
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }